export const POS_PARAM_EXT = 'ext';
export const POS_PARAM_LANG = 'language';
